import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { PetService } from '../../../services/pet/pet.service';
import { catchError, EMPTY } from 'rxjs';
import { Pet } from '../../models/pet.model';

export const petResolver: ResolveFn<Pet> = (route) => {
  const petService = inject(PetService);
  const router = inject(Router);
  const petId = route.paramMap.get('petId')!;

  return petService.getPetById(petId).pipe(
    catchError(() => {
      router.navigate(['/not-found'], {
        queryParams: { details: 'O Pet informado não existe' },
        queryParamsHandling: 'merge'
      });
      return EMPTY;
    })
  );
};
